module.exports = __webpack_public_path__ + "img/MD.d25dc7b6.png";